<lyceo-content [background]="true">
  <lyceo-single-card-layout>
    <h3 class="mb-3">404</h3>
    <p class="mb-3">Deze pagina is niet beschikbaar.</p>
    <button lyceoButton [block]="true" (click)="home()" data-testid="button">
      Terug naar home
    </button>
  </lyceo-single-card-layout>
</lyceo-content>
